import { LineChart } from '@mui/x-charts/LineChart'

export const SerpEvolutionChart = ({ history }) => {
  if (!history || history.length < 2) {
    return <div style={{ width: 80, height: 24 }} />
  }

  const xData = history.map(d => d.date ? new Date(d.date) : null)
  const yData = history.map(d => d.rankGroup ?? null)

  if (xData.some(d => !d) || yData.some(y => typeof y !== 'number')) {
    return <div style={{ width: 80, height: 24 }} />
  }

  return (
    <LineChart
      xAxis={[
        {
          data: xData,
          scaleType: 'time',
          valueFormatter: (date: Date) => date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
        }
      ]}
      series={[
        {
          data: yData,
          showMark: false,
          color: '#1976d2',
          area: true
        }
      ]}
      height={32}
      leftAxis={null}
      bottomAxis={null}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      sx={{
        '.MuiAreaElement-root': {
          fill: 'rgba(25, 118, 210, 0.15)',
          strokeWidth: 1.5
        }
      }}

      slotProps={{
        legend: { hidden: true }
      }}



    />
  )
}

export default SerpEvolutionChart;